<template>
  <validation-observer ref="observer" v-if="shaft && shaft.input_channel">
    <form @submit.prevent="submit" class="pt-2">
      <validation-provider
        v-slot="{ errors }"
        name="dn"
        rules="required"
        mode="lazy"
      >
        <v-select
          v-model="shaft.input_channel.diameter"
          :items="channelChoices"
          :error-messages="errors"
          label="Durchmesser *"
          data-vv-name="dn"
          item-text="dn_label"
          item-value="id"
          return-object
          outlined
          color="grey darken-2"
          :disabled="shaft.ordered"
        >
        </v-select>
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="material"
        rules="required"
        mode="lazy"
        v-if="
          !shaft.input_channel.diameter || shaft.input_channel.diameter.dn > 0
        "
      >
        <v-select
          v-model="shaft.input_channel.material"
          :items="subMaterialChoices"
          :error-messages="errors"
          label="Material *"
          data-vv-name="material"
          item-text="material"
          item-value="material"
          outlined
          color="grey darken-2"
          :disabled="shaft.ordered || subMaterialChoices.length === 0"
        >
        </v-select>
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="title"
        rules="max:255"
        mode="lazy"
        v-if="
          !shaft.input_channel.diameter || shaft.input_channel.diameter.dn > 0
        "
      >
        <v-text-field
          v-model="shaft.input_channel.note"
          :error-messages="errors"
          label="Fabrikat"
          outlined
          color="grey darken-2"
          :disabled="shaft.ordered"
        >
        </v-text-field>
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="tilt"
        rules="integer"
        mode="lazy"
        v-if="
          !shaft.input_channel.diameter || shaft.input_channel.diameter.dn > 0
        "
      >
        <v-text-field
          v-model="shaft.input_channel.tilt"
          :error-messages="errors"
          label="Muffenschrägstellung"
          suffix="‰"
          outlined
          color="grey darken-2"
          :disabled="shaft.ordered"
        >
        </v-text-field>
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="slope"
        rules="required|integer"
        mode="lazy"
        v-if="
          !shaft.input_channel.diameter || shaft.input_channel.diameter.dn > 0
        "
      >
        <v-text-field
          v-model="shaft.slope"
          :error-messages="errors"
          label="Gefälle Hauptgerinne *"
          suffix="%"
          outlined
          color="grey darken-2"
          :disabled="shaft.ordered"
        ></v-text-field>
      </validation-provider>
      <div class="my-4 text-center">
        <v-btn
          color="primary"
          class="text-center"
          type="submit"
          :loading="isSubmitting"
          outlined
        >
          Weiter
        </v-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'FormEditShaft2',
  components: {},
  props: ['shaft', 'materialChoices'],
  data: () => ({
    isSubmitting: false,
    subMaterialChoices: [],
  }),
  computed: {
    ...mapGetters([]),
    channelChoices() {
      if (this.shaft.type && this.shaft.type.channel_options) {
        let options = [...this.shaft.type.channel_options];
        const index = options.findIndex(option => option.dn === 0);
        if (
          index >= 0 &&
          this.shaft.output_channel.diameter &&
          this.shaft.output_channel.diameter.dn === 0
        )
          options.splice(index, 1);
        return options;
      }
      return [];
    },
  },
  watch: {
    shaft: {
      handler() {
        if (this.shaft && !this.shaft.input_channel)
          this.shaft.input_channel = {};

        this.updateSubmaterials();
      },
      deep: true,
    },
    materialChoices() {
      this.updateSubmaterials();
    },
  },
  mounted() {
    if (this.shaft && !this.shaft.input_channel) this.shaft.input_channel = {};
    this.updateSubmaterials();
  },
  methods: {
    ...mapActions(['updateCurrentShaft']),
    submit() {
      this.$refs.observer.validate().then(async success => {
        if (!success) {
          return;
        }
        this.isSubmitting = true;
        try {
          if (
            this.shaft.input_channel.diameter &&
            this.shaft.input_channel.diameter.dn === 'Ende'
          )
            this.shaft.input_channel = undefined;
          if (!this.shaft.ordered) await this.updateCurrentShaft(this.shaft);
          this.$emit('submit');
        } catch {
          // ignored
        }
        this.isSubmitting = false;
      });
    },
    clear() {
      this.$refs.observer.reset();
    },
    updateSubmaterials() {
      this.subMaterialChoices = [...this.materialChoices];
      if (this.subMaterialChoices.length === 0) return;

      // grab materials that are possible with the chosen diameter
      if (
        this.shaft &&
        this.shaft.input_channel &&
        this.shaft.input_channel.diameter
      ) {
        this.subMaterialChoices = [];
        this.materialChoices.forEach(material => {
          if (
            material.diameters.includes(
              '' + this.shaft.input_channel.diameter.dn,
            )
          )
            this.subMaterialChoices.push(material);
        });
      }

      // check if current material is still in list, otherwise reset
      if (
        this.shaft &&
        this.shaft.input_channel &&
        this.shaft.input_channel.material
      ) {
        var index = this.subMaterialChoices.findIndex(
          material => material.material === this.shaft.input_channel.material,
        );
        if (index < 0) this.shaft.input_channel.material = undefined;
      }
    },
  },
};
</script>

<style scoped></style>
